import React, { memo, useContext, useMemo } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import AIEngineSelector from 'Pods/ThreeDStudio/Shared/AIEngineSelector/AIEngineSelector'
import GenerateArea from 'Pods/ThreeDStudio/Shared/GenerateArea/GenerateArea'
import { getHiddenEnhancedProviders } from 'Pods/ThreeDStudio/Shared/Utils/getHiddenEnhancedProviders'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { ACTION } from 'Pods/ThreeDStudio/Store/constants'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

import AnimationLibrary from './Components/AnimationLibrary/AnimationLibrary'
import ComingSoon from './Components/ComingSoon/ComingSoon'

function AnimateTab() {
  const t = useTranslation()
  const { enableAnimation } = useContext(ThreeDStudioPageContext)
  const animationId = useThreeDStudioStore(state => state.animateSettings.animationId)
  const hiddenProviders = useMemo(() => getHiddenEnhancedProviders(ACTION.ANIMATION), [])

  if (!enableAnimation) {
    return <ComingSoon />
  }

  return (
    <>
      <div className="enhance-model-panel__tab animate-tab">
        <div className="animate-tab__rig">
          <span className="enhance-model-panel__title cgt-heading-50">
            {t('viewerSidebar.enhance.animate.title')}
          </span>
          <p className="animate-tab__rig-description cgt-body-base">
            {t('viewerSidebar.enhance.animate.rigDescription')}
          </p>
        </div>
        <div className="enhance-model-panel__settings">
          <AIEngineSelector isEnhanced hiddenProviders={hiddenProviders} />
        </div>
        <AnimationLibrary />
      </div>
      <GenerateArea
        generateLabel={t('viewerSidebar.enhance.animate.generateLabel')}
        generatedLabel={t('viewerSidebar.enhance.common.done')}
        generatingLabel={t('viewerSidebar.enhance.common.processing')}
        isEnhancementMode
        isGenerateDisabled={!animationId}
        withIcon={false}
      />
    </>
  )
}

export default memo(AnimateTab)
